import { Button, Flex, Title } from '@libs/ui/ds'
import { Controller } from '@libs/ui/form'
import { useMemberPageTranslation } from '@libs/utils/translations'
import { FormGroup, FieldLabel } from '@spa/components/FormFields'
import { useContractTypes } from '@spa/scenes/MemberPage/constants'
import type { FC } from 'react'
import { type Control, type FieldErrors } from 'react-hook-form'
import { useAuthorizedContractTypes } from 'snap-redux/modules/countryConfigurations/selectors'

type Props = {
  setIsCreatingNewContract(display: boolean): void
  onMoveToNewContractSubmit(): void
  isLoadingPlannables: boolean
  control: Control
  errors: FieldErrors
}
const MoveToNewContract: FC<Props> = ({
  isLoadingPlannables,
  control,
  errors,
  onMoveToNewContractSubmit,
  setIsCreatingNewContract
}) => {
  const { t, tCommon } = useMemberPageTranslation()

  const handleCancelCreationOfNewContract = () =>
    setIsCreatingNewContract(false)

  const authorizedContractTypes = useAuthorizedContractTypes()
  const contractsTypes = useContractTypes({ authorizedContractTypes })?.map(
    ({ value, label }) => ({
      value,
      label
    })
  )

  return (
    <div className='mt-2'>
      <Title size={4}>{t('contract.form.move')}</Title>
      <FormGroup
        id='new_contract_type'
        fieldLabel={<FieldLabel label={t('contract.form.type')} />}
        fieldForm={
          <Controller.Select
            name='new_contract_type'
            control={control}
            errorMessage={errors?.new_contract_type?.message as any}
            options={contractsTypes}
          />
        }
      />
      <FormGroup
        id='new_contract_start'
        fieldLabel={<FieldLabel label={t('contract.form.startDate')} />}
        fieldForm={
          <Controller.DatePickerInput
            name='new_contract_start'
            control={control}
            errorMessage={errors?.new_contract_start?.message?.toString()}
          />
        }
      />
      <FormGroup
        id='new_contract_end'
        fieldLabel={<FieldLabel label={t('contract.form.endDate')} />}
        fieldForm={
          <Controller.DatePickerInput
            name='new_contract_end'
            control={control}
            errorMessage={errors?.new_contract_end?.message?.toString()}
            disabled={isLoadingPlannables}
          />
        }
      />

      <Flex className='gap-2'>
        <Button
          onClick={onMoveToNewContractSubmit}
          disabled={isLoadingPlannables}
          fillWidth
        >
          {t('contract.form.submit')}
        </Button>
        <Button
          intent='danger'
          onClick={handleCancelCreationOfNewContract}
          fillWidth
        >
          {tCommon('action.cancel')}
        </Button>
      </Flex>
    </div>
  )
}

export default MoveToNewContract
